import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=061f4a5f&scoped=true"
import script from "./SelectCustomer.vue?vue&type=script&lang=js"
export * from "./SelectCustomer.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=061f4a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f4a5f",
  null
  
)

export default component.exports